<div [formGroup]="getFormGroup()" [hidden]="getHidden()" [class]="getStyleClass()" [class.oneline-control]="getOneLineControl()">
  <label class="control-label bs-label th-text-main fw-bold" [class.oneline-label-control]="getOneLineControl()">
    {{getLabelValue()}}
    <span class="required-span" *ngIf="getRequired()">*</span>
  </label>
  <div class="input-group input-group-width bs-input-div th-bg-input th-input-border"
       [class.oneline-control-div]="getOneLineControl()"
       (click)="togglePicker()"
       [class.col-10]="getOneLineControl()" [class.float-right]="getOneLineControl()">

    <input type="text" autocomplete="off" [(ngModel)]="currentData" #el class="form-control bs-input th-bg-input th-text-dark-gray" [name]="getModelId()"
          [formControlName]="getModelId()" [id]="getId()" #dp="bsDatepicker" bsDatepicker
          (keyup.enter)="onEnter()" [required]="getRequired()" [disabled]="getReadOnly()" 
          [class.th-bg-disabled]="getReadOnly()" (click)="event2('onClick')"
          [placeholder]="getPlaceHolder()" [title]="getTooltipMessage()?getTooltipMessage():''" 
          [style]="'text-align:' + getTextOrientation()" />
        
        <div class="vr th-input-border"></div>
        <!-- It's container of the icon of the inputs. -->
        <div class="bs-icon-div th-input-icon th-bg-input">
                <a class="bs-a th-a"
                [class.bs-disabled-a]="getReadOnly()">
                  <span class="input-group-text bs-icon th-bg-input"
                      [class.th-bg-input-alert]="!this.getIsValid()"
                      [class.th-bg-disabled]="getReadOnly()">
                         <i class="fa fa-calendar"></i>
                  </span> 
                </a>
        </div>
  </div>
  <small class="help-block bs-error th-text-alert" style="padding-left: 0" [class.col-sm-10]="getOneLineControl()"
    [class.pull-right]="getOneLineControl()" *ngIf="el.errors?.required && el.touched">{{getRequiredMessage()}}
  </small>
</div>

